export const toStringKey = (oId, vId) => oId + "_" + vId
export const fromStringKey = str => str.split("_")

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}



export function randInt(max) {
    return Math.floor(Math.random() * max);
}

export function twoRands(max) {
    const index1 = randInt(max)
    const index2 = (index1 + randInt(max)) % max
    return [index1, index2]
}

/**
 *
 * Unicode and null Safe comparison
 * of two Strings
 *
 * Normalizes a & b if both are
 * strings.
 *
 *
 *
 * @param a: string
 * @param b: string
 *
 * @return boolean
 */
export function uEqual( a, b )
{
    if( typeof a === 'string' && typeof b === 'string' ) {
        return a.normalize() === b.normalize();
    }

    return a === b;
}


/**
 * https://stackoverflow.com/questions/5899783/detect-safari-using-jquery
 *
 * @return boolean
 */
export function isSafari()
{
    var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
    var is_safari = navigator.userAgent.indexOf("Safari") > -1;

    // Chrome contains both strings and would return true if only testet for safari
    // Same holds true for Opera https://www.whatismybrowser.com/guides/the-latest-user-agent/opera
    // Safari was the first to adapt KTHML, then Chrome, den Opera
    return is_safari && !is_chrome;
}
